import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Popover,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {CreateReceiptSVG, ExcelSVG, ListIconSVG, PlusWhiteSVG} from "assets";
import {ButtonExcel, InputFields, ListActionButton} from "components/common";
import ColumnPopoverDisplay from "components/common/PopoverTable/PopoverTable";
import React, {useEffect, useMemo, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {columns as columnsInit} from "./config";
import {ColumnProps} from "types/models";
import {LOAI_FORM, LOAI_PHIEU_KHO, TT_PHIEU_KHO, tabKeys} from "types/enums";
import Icon from "assets/icons";
import ModalResults from "./ModalResults/ModalResults";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {fields} from "./config";
import {setActiveKey} from "redux/reducer/common";
import {glassStoreService} from "api";
import "./Store.scss";
import {
  getListGlassInStoreAPI,
  getListLoaiVTAPI,
  getListStore,
  getListStorePhanQuyen,
  setSelectGlassExport,
  setStatusPhieu,
  setTypeForm,
  setTypePhieu,
  updateDetailLo,
} from "redux/reducer/glassStore";
import {components} from "./EditTable";
import Notification from "components/common/notification/notification";
import {exportFile, isValuable} from "helper/common";
import ButtonPdf from "components/common/ButtonPdf/ButtonPdf";

const GlassStorehouseSub = () => {
  const [form] = Form.useForm();
  const [columns, setColumns] = useState<any[]>(
    columnsInit.filter(e => e.show == true)
  );
  const [{nhaCungCap, tongVt, tongVtHh}, setCount] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [soLo, setSoLo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const activeTab = useAppSelector(e => e.common.activeTab);
  const [isShowModal, setIsShowModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [dataFields, setDataFields] = useState<any[]>(fields);
  const dispatch = useAppDispatch();
  const glassStore = useAppSelector(state => state.glassStore);
  const selectedGlassExport = useAppSelector(
    state => state.glassStore.selectGlass
  );
  const [paramsSearch, setParamsSearch] = useState<any>({
    limit: limit,
    page: currentPage,
  });
  const value = [
    {name: "Tổng số vật tư kính còn trong kho:", quantity: tongVt},
    {name: "Tổng số vật tư hết hàng (tồn kho = 0):", quantity: tongVtHh},
    {name: "Tổng số nhà cung cấp:", quantity: nhaCungCap},
  ];
  const showModal = () => {
    setIsShowModal(true);
  };

  useEffect(() => {
    dispatch(getListStorePhanQuyen());
    dispatch(getListLoaiVTAPI());
  }, []);
  useEffect(() => {
    dataFields.find(e => e.name == "storeId").onChange = e1 => {
      getCountByStore(e1);
    };
  }, []);
  const getCountByStore = async storeId => {
    try {
      const res = await glassStoreService.getCountByStore(storeId);
      setCount(res);
    } catch (error) {}
  };
  useEffect(() => {
    columns.find(e => e.dataIndex == "action").render = (
      value,
      record,
      index
    ) => {
      return (
        <ListActionButton
          toolTipSave={"Cập nhật thông tin lô"}
          showDetailFunction={() => {
            setIsShowModal(true);
            setSoLo(record?.soLo);
          }}
          saveFunction={() => {
            const params = {
              id: record.id,
              donGiaNhap: record?.donGiaNhap,
              donGiaBan: record?.donGiaBan,
              note: record?.note,
            };
            dispatch(updateDetailLo(params));
            // call api luu thông tin lô
          }}
        ></ListActionButton>
      );
    };

    setColumns(columns);
  }, [data]);
  useEffect(() => {
    setData(
      glassStore.listGlassInStore.map(e => ({
        ...e,
        key: e.id,
        xuatDuKien: 0,
      }))
    );
  }, [glassStore.listGlassInStore]);
  useEffect(() => {
    if (glassStore.listStore) {
      const khoTongId = glassStore.listStore.find(
        e => e?.name == "Kho tổng"
      )?.id;
      dataFields.find(e => e.name == "storeId").options =
        glassStore.listStore.map(e => {
          return {value: e.id, label: e.name};
        });
      // setDataFields([...fields]);
      form.setFieldValue("storeId", khoTongId);
      getCountByStore(khoTongId);
      const khoPhanQuyen = glassStore?.listStore?.[0]?.id;
      form.setFieldValue("storeId", khoPhanQuyen);
      setParamsSearch({...paramsSearch, storeId: khoTongId ?? khoPhanQuyen});
    }
  }, [glassStore.listStore]);
  useEffect(() => {
    if (glassStore.listLoaiVT) {
      dataFields.find(e => e.name == "loaiVatTuId").options =
        glassStore.listLoaiVT.map(e => {
          return {value: e.id, label: e.name};
        });
      // setDataFields([...fields]);
    }
  }, [glassStore.listLoaiVT]);
  useEffect(() => {
    setColumns(
      columnsInit
        .map(col => {
          if (!col.editable) {
            if (col.dataIndex === "index") {
              return {
                title: "STT",
                key: "index",
                show: true,
                dataIndex: "index",
                render(_, __, index) {
                  return (
                    <>
                      {index + 1 + (paramsSearch.page - 1) * paramsSearch.limit}
                    </>
                  );
                },
                fixed: "left",
                width: 50,
                align: "center",
              };
            } else {
              return col;
            }
          }
          return {
            ...col,
            onCell: (record: any) => ({
              record,
              editable: true,
              dataIndex: col.dataIndex,
              title: col.title,
              type: col?.type,
              handleSave,
            }),
          };
        })
        .filter(e => e.show == true)
    );
  }, [data]);

  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });

    setData(newData);
  };

  const handleCancel = () => {
    setIsShowModal(false);
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };

  const onSearch = async () => {
    const data = await form.getFieldsValue();
    setParamsSearch({...paramsSearch, ...data, page: 1});
    setCurrentPage(1);
  };
  const onChangePagination = (page, pageSize) => {
    setParamsSearch({...paramsSearch, page: page, limit: pageSize});
  };
  useEffect(() => {
    getListGlassInStore();
  }, [paramsSearch]);

  const getListGlassInStore = async () => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(getListGlassInStoreAPI(paramsSearch));
    setLoading(false);
  };

  //cấu hình trang cho bảng

  useEffect(() => {
    getListGlassInStore();
  }, [paramsSearch, currentPage]);

  useMemo(() => {
    if (tabKeys.GLASSES_STOREHOUSE.STORE_GLASS === activeTab) {
    }
  }, [activeTab, currentPage]);

  const rowSelection = {
    selectedRowKeys,
    onChange: async (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      dispatch(setSelectGlassExport(selectedRows));
    },
    getCheckboxProps: (record: any) => ({
      disabled: record["tonKho"] == null || record["tonKho"] <= 0, // Column configuration not to be checked
      name: record.name,
    }),
  };

  const handleOnCreat = () => {
    if (selectedGlassExport.length == 0) {
      Notification("warning", "Chưa chọn vật tư kính để tạo phiếu xuất");
    } else {
      dispatch(setStatusPhieu(TT_PHIEU_KHO.NHAP));
      dispatch(setTypeForm(LOAI_FORM.TAO_MOI));
      dispatch(setTypePhieu(LOAI_PHIEU_KHO.XUAT));
      navigateTab();
    }
  };

  const handleOnReload = () => {
    form.resetFields();
    onSearch();
  };

  const navigateTab = () => [
    dispatch(setActiveKey(tabKeys.GLASSES_STOREHOUSE.DETAIL)),
  ];

  const onChange = (e: CheckboxChangeEvent) => {
    setParamsSearch({...paramsSearch, isEmpty: e.target.checked});
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onSearch();
    }
  };
  const getReportFile = async () => {
    const params = {
      storeId: form.getFieldValue("storeId"),
      isEmpty: null,
    };
    if (isValuable(form.getFieldValue("storeId"))) {
      const tenKho = glassStore.listStore.find(
        e => e.id == params?.storeId
      ).name;

      exportFile(
        "store/glasses-store/export-ton-kho",
        params,
        `Báo cáo tồn kho - ${tenKho}`
      );
    } else {
      Notification("warning", "Chưa chọn kho");
    }
  };
  const getReportFilePdf = async () => {
    const params = {
      storeId: form.getFieldValue("storeId"),
      isEmpty: null,
    };
    if (isValuable(form.getFieldValue("storeId"))) {
      const tenKho = glassStore.listStore.find(
        e => e.id == params?.storeId
      ).name;

      exportFile(
        "store/glasses-store/export-ton-kho-pdf",
        params,
        `Báo cáo tồn kho - ${tenKho}`,
        "pdf"
      );
    } else {
      Notification("warning", "Chưa chọn kho");
    }
  };
  const getReportFileTheoVT = async () => {
    const params = {
      khoId: form.getFieldValue("storeId"),
    };
    if (isValuable(form.getFieldValue("storeId"))) {
      const tenKho = glassStore.listStore.find(e => e.id == params?.khoId).name;

      exportFile(
        "store/kinh-vt/export-danh-muc-kinh",
        params,
        `Báo cáo tồn kho theo vật tư - ${tenKho}`
      );
    } else {
      Notification("warning", "Chưa chọn kho");
    }
  };

  return (
    <div className="glass-storehouse">
      <div className="container">
        <Form form={form} labelAlign="left" onKeyDown={onKeyDown} tabIndex={0}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]} justify={"space-between"}>
              <InputFields data={dataFields} />
            </Row>
            <Row
              className="btn-row"
              gutter={[16, 16]}
              justify={"space-between"}
            >
              <Col>
                <Checkbox onChange={onChange}>Hiển thị số lượng = 0</Checkbox>
              </Col>
              <Col>
                <Space>
                  <Button
                    className="btn-sub"
                    icon={<Icon.reload />}
                    onClick={handleOnReload}
                  >
                    Xoá tìm kiếm
                  </Button>
                  <Button
                    onClick={onSearch}
                    type="primary"
                    icon={<Icon.search />}
                  >
                    Tìm kiếm
                  </Button>
                </Space>
              </Col>
            </Row>
          </Space>
        </Form>
      </div>

      <div className="container">
        <Row gutter={[16, 16]}>
          <Space
            style={{width: "100%", display: "contents"}}
            size={"small"}
            direction="horizontal"
            split={<Divider type="vertical" />}
          >
            {value.map(item => (
              <div key={item.name}>
                {item.name}{" "}
                <Typography.Text style={{fontWeight: "bold"}} ellipsis={true}>
                  {item.quantity}
                </Typography.Text>
              </div>
            ))}
          </Space>
        </Row>
      </div>

      <div className="container">
        <Space style={{width: "100%"}} direction="vertical" size={"small"}>
          <Typography.Text style={{fontWeight: "bold"}} ellipsis={true}>
            Danh sách vật tư kính
          </Typography.Text>
          {/* <Divider /> */}
          <Row gutter={[16, 16]} justify={"end"}>
            <Col>
              <Space>
                <ButtonPdf
                  onClick={getReportFilePdf}
                  title="Báo cáo tồn kho"
                ></ButtonPdf>
                <ButtonExcel
                  onClick={getReportFile}
                  title="Báo cáo tồn kho"
                ></ButtonExcel>
                <ButtonExcel
                  onClick={getReportFileTheoVT}
                  title="Báo cáo tồn kho theo vật tư"
                ></ButtonExcel>
                <Button
                  className="btn-sub"
                  icon={<CreateReceiptSVG />}
                  onClick={handleOnCreat}
                >
                  Tạo phiếu xuất
                </Button>

                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                    />
                  }
                >
                  <Button icon={<ListIconSVG />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>
              </Space>
            </Col>
          </Row>
          {data && (
            <Table
              className="table-store"
              bordered
              loading={loading}
              dataSource={data}
              columns={columns}
              // scroll={{x: 1600}}
              components={components}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                total: glassStore.totalGlassInStore,
                onChange: onChangePagination,
              }}
              rowSelection={{
                ...rowSelection,
              }}
            />
          )}
        </Space>
      </div>
      <ModalResults
        soLo={soLo}
        isShowModal={isShowModal}
        handleOk={showModal}
        handleCancel={handleCancel}
      />
    </div>
  );
};

export default GlassStorehouseSub;
